import React from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { TextField } from '@material-ui/core';

import RichTextEditor from 'components/RichTextEditor';

import { ChallengeFormData } from '../types';

interface DescriptionStepProps {
  control: Control<ChallengeFormData>;
  errors: FieldErrors<ChallengeFormData>;
}

const MAX_TITLE_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 5000;

function DescriptionStep({ control, errors }: DescriptionStepProps): JSX.Element {
  return (
    <div>
      <Controller
        name="totalHeadline"
        control={control}
        rules={{
          required: 'Headline is required',
          maxLength: {
            value: MAX_TITLE_LENGTH,
            message: `Maximum ${MAX_TITLE_LENGTH} characters allowed`,
          },
        }}
        render={({ field: controllerField }) => (
          <TextField
            {...controllerField}
            label="Headline *"
            fullWidth
            variant="outlined"
            error={!!errors.totalHeadline}
            helperText={errors.totalHeadline?.message || `Max. ${MAX_TITLE_LENGTH} characters`}
            style={{ marginBottom: '20px' }}
          />
        )}
      />

      <Controller
        name="totalText"
        control={control}
        rules={{
          required: 'Description is required',
          validate: (value) => {
            const textContent = value?.replace(/<[^>]+>/g, '').trim();
            if (textContent && textContent.length > MAX_DESCRIPTION_LENGTH) {
              return `Maximum ${MAX_DESCRIPTION_LENGTH} characters allowed`;
            }
            return true;
          },
        }}
        render={({ field: controllerField, fieldState }) => (
          <RichTextEditor
            value={controllerField.value || ''}
            onChange={controllerField.onChange}
            label="Description *"
            helperText={`Max. ${MAX_DESCRIPTION_LENGTH} characters`}
            height={200}
            error={!!fieldState.error}
            errorMessage={fieldState.error?.message}
          />
        )}
      />
    </div>
  );
}

export default DescriptionStep;
